module.exports = __webpack_public_path__ + "img/platform_main_img1.28ce8876.jpg";